import { useEffect, useRef, useState, type JSX } from 'react';
import { SkeletonLoader } from '@/components/ui';
import WidgetRenderer from '@/components/widgets/WidgetRenderer';
import { fetchHomePage } from '@/services/slaydAPI';
import type { Widget } from '@/types/widgets';
import styles from './HomePage.module.css';

const HomePage = (): JSX.Element => {
  const [widgets, setWidgets] = useState<Widget[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const fetchingWidgetData = useRef<boolean>(false);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      if (fetchingWidgetData.current) return;

      try {
        fetchingWidgetData.current = true;

        const response = await fetchHomePage();

        setWidgets(response.widgets);
      } catch (err) {
        console.error(err);
      } finally {
        fetchingWidgetData.current = false;
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return isLoading ? (
    <div className={styles.homePageContainer} style={{ overflowY: 'hidden' }}>
      {SkeletonLoader.search()}
      {Array.from({ length: 4 }).map((_, idx) => (
        <div key={idx}>{SkeletonLoader.curationCard()}</div>
      ))}
    </div>
  ) : (
    <div className={styles.homePageContainer}>
      <WidgetRenderer widgets={widgets} />
    </div>
  );
};

export default HomePage;
